<div class="flex flex-col my-3 border-solid lg:w-3/5 border-grey-100 border-[1px] bg-grey-50 rounded-lg px-4 py-2" [ngClass]="{'py-4':optionOpen}">
  <div class="flex flex-start " (click)="switchOpen()">
    <p class=" text-2xl hover:cursor-pointer my-0 py-0 font-bold">{{optionsHolder.SectionName}} </p>
    @if (!optionOpen) {
      <span class="text-3xl  material-symbols-outlined  hover:cursor-pointer  my-0 py-0">chevron_right</span>
    }
    @if (optionOpen) {
      <span class="text-3xl material-symbols-outlined hover:cursor-pointer my-0 py-0">keyboard_arrow_down</span>
    }
  </div>
  @if (optionOpen) {
    <div class="mx-3 ">
      @for (a of optionsHolder.Options; track a; let even = $even) {
        <div class="mt-1" (click)="goToPage(a.URL)"  >
          <p class="text-lg hover:cursor-pointer hover:underline">{{a.MenuName}} ></p>
          <p class="text-sm ml-4 text-grey-900 -mt-0 mb-2 italic">{{a.HelpText}}</p>
        </div>
      }
    </div>
  }

</div>